import { render, staticRenderFns } from "./campainList.vue?vue&type=template&id=df56a7e0&"
import script from "@/scripts/promotion/campainList.js?vue&type=script&lang=js&"
export * from "@/scripts/promotion/campainList.js?vue&type=script&lang=js&"
import style0 from "./campainList.vue?vue&type=style&index=0&id=df56a7e0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports